import _toConsumableArray from "D:/coding/pmv5-fe/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import pageMixin from "../mixins/page";
import Axios from "axios";
import ProductModal from "./ProductModal.vue";
export default {
  name: "product-list",
  mixins: [pageMixin],
  components: {
    ProductModal: ProductModal
  },
  data: function data() {
    return {
      searchText: "",
      columns: [{
        type: "selection",
        width: 60,
        align: "center"
      }, {
        title: "产品名称",
        sortable: true,
        key: "product_name"
      }, {
        title: "产品类型",
        key: "product_type",
        sortable: true
      }, {
        title: "激活接口",
        key: "license_interface",
        sortable: true
      }, {
        title: "功能定义",
        key: "affect",
        sortable: true
      }, {
        title: "是否停用",
        key: "product_status",
        sortable: true
      }],
      data: [],
      selection: [],
      showAddModal: false,
      showUpdateModal: false,
      licenseinterfaces: []
    };
  },
  created: function created() {
    this.refresh();
  },
  methods: {
    refresh: function refresh() {
      var _this = this;
      var onFinish = this.setLoading.bind(this, false);
      this.setLoading(true);
      Axios.get("fenxiang/configs/", {
        params: {
          name: this.searchText,
          order_by: this.sortKey,
          page: this.currentPage,
          per_page: this.pageSize
        }
      }).then(function (resp) {
        _this.data = resp.data;
        _this.total = _this.data.length; //Todo : 等待后端接口吧count信息返回再修改为this.setPageVars(resp.data.page_info)
      }).then(onFinish, onFinish);
    },
    removeProducts: function removeProducts() {
      var _this2 = this;
      var sel = this.selection[0];
      Axios.delete("fenxiang/delete_config/", {
        id: sel.id
      }).then(function () {
        _this2.refresh();
      });
    },
    deactiveProducts: function deactiveProducts() {
      var _this3 = this;
      var sel = this.selection[0];
      Axios.delete("fenxiang/undercarriage/", {
        id: sel.id,
        product_status: 1
      }).then(function () {
        _this3.refresh();
      });
    },
    onModalClose: function onModalClose(val) {
      val && this.refresh();
    },
    onSelectionChange: function onSelectionChange(rows) {
      var _this$selection;
      this.selection.length = 0;
      (_this$selection = this.selection).push.apply(_this$selection, _toConsumableArray(rows));
    }
  }
};